<template>
    <div class="table-container">
        <el-table
            :data="domains"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column
                prop="name"
                label="名称"
                show-overflow-tooltip
                min-width="180"
            >
            </el-table-column>
            <el-table-column
                prop="is_enabled"
                label="状态"
                width="90"
                :formatter="boolFormatter"
            >
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <el-button
                        @click="edit(scope.row)"
                        type="text"
                        size="mini"
                    >编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <ox-safe-button
                        @confirm="remove(scope.row)"
                        type="text"
                        size="small"
                    >删除</ox-safe-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { fmtMixin } from "@/ox/Mixins";
import OxSafeButton from '@/ox/components/OxSafeButton';

export default {
    name: "DomainTable",
    mixins: [fmtMixin],
    components:{
        OxSafeButton
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            domains: []
        };
    },

    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.isLoading = true;
            const query = new window.BaaS.Query();
            query.compare('category', '=', 'technique')
            this.$ox
                .service("domain")
                .find(query, {
                    pageSize: 50,
                    orderBy: ["prior"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.domains = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        edit(row) {
            this.$parent.$refs.dialog.show(row)
        },
        remove(row){
            this.$ox.service('domain').delete(row.id).then(()=>{
                this.domains = this.domains.filter(domain=>domain.id!==row.id)
                this.$notify.success({
                  title: '操作成功',
                  message: `分类“${row.name}”已删除`
                });
            })
        }
    }
};
</script>

<style scoped>
</style>
